import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateWorkLogScopes } from '@/entities/work-log';
import { addAttachment, removeAttachment } from '../api';
import type { AddAttachmentRequest } from '../api';

export function useAddAttachment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: { workLogId: string; dto: AddAttachmentRequest }) =>
      addAttachment(params.workLogId, params.dto),
    onSuccess: () => {
      // 첨부는 일지에 딸린 것이라 **집계 둘 다 무관**하다 — 일지 수도, `SUBMITTED` 건수도,
      // `revisionCount` 도 바뀌지 않는다.
      invalidateWorkLogScopes(queryClient, ['list', 'today']);
    },
  });
}

export function useRemoveAttachment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: { workLogId: string; attachmentId: string }) =>
      removeAttachment(params.workLogId, params.attachmentId),
    onSuccess: () => {
      invalidateWorkLogScopes(queryClient, ['list', 'today']);
    },
  });
}
